import styled from 'styled-components';
import Button from '@nebula/button';
import { TitleMedium500, BodyMedium400, TitleLarge, BodyLarge } from '@nebula/global-styles';

const tabletPortraitMin = ({ theme }) => theme.media.tabletPortraitMin;

export const InformationCard = styled.div`
  border: none;
  border-radius: 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1.5rem;
  padding: 1rem;

  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    padding: 1.5rem;
    margin-bottom: 2rem;
  }
`;
export const PaymentAndBillingBannerLayout = styled(InformationCard)`
  background-color: ${({ theme }) => theme.color.ui.grey[10]};
`;

export const PaymentAndBillingBannerTitle = styled(TitleMedium500)`
  @media ${tabletPortraitMin} {
    ${TitleLarge}
  }
  margin: 0;
`;

export const PaymentAndBillingBannerBody = styled(BodyMedium400)`
  @media ${tabletPortraitMin} {
    ${BodyLarge}
  }
  margin: 0;
`;

export const PaymentAndBillingBannerButton = styled(Button)`
  align-self: flex-start;
  font-size: 1rem;
  padding: 0;
  height: 2rem;
`;
